import { clampTo, hasImageInput, resolveImageSize } from '../../tools';
import type { alibabaModelConfig } from '../types';

export const wanConfigs: Record<string, alibabaModelConfig> = {
    'wan2.7-image-pro': {
        // https://bailian.console.aliyun.com/cn-beijing?spm=5176.12818093_47.overview_recent.3.e8292cc9QWCSs5&tab=api#/api/?type=model&url=3026980
        apiPath: '/api/v1/services/aigc/image-generation/generation',
        pollApiPath: '/api/v1/tasks/{id}',
        statusMapping: {
            taskIdPath: 'output.task_id',
            createErrorPath: 'message',
            statePath: 'output.task_status',
            success: ['SUCCEEDED'],
            failed: ['FAILED', 'CANCELED', 'UNKNOWN'],
            processing: ['PENDING', 'RUNNING'],
            imageUrlPath: 'output.choices[0].message.content[0].image',
            errorPath: 'output.message',
        },
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, aspectRatio, image_resolution, providerOptions } = params;
            const hasImage = hasImageInput(image_urls);
            if (hasImage) {
                const images = image_urls.slice(0, 9);
                return {
                    model: 'wan2.7-image-pro',
                    input: {
                        messages: [
                            {
                                role: 'user',
                                content: [
                                    {
                                        text: prompt.slice(0, 5000),
                                    },
                                    // 图片 URL
                                    ...images.map(url => ({
                                        image: url,
                                    })),
                                ]
                            }
                        ]
                    },
                    parameters: {
                        size: clampTo(image_resolution || '1K', ['1K', '2K'] as const, '1K'),
                        seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                        // 可选参数
                        watermark: typeof providerOptions?.watermark === 'boolean' ? providerOptions.watermark : false,
                        // system
                        bbox_list: undefined,
                        enable_sequential: false,
                        n: 1,
                        color_palette: undefined,
                    },
                };
            } else {
                return {
                    model: 'wan2.7-image-pro',
                    input: {
                        messages: [
                            {
                                role: 'user',
                                content: [
                                    {
                                        text: prompt.slice(0, 5000),
                                    },
                                ]
                            }
                        ]
                    },
                    parameters: {
                        size: resolveImageSize(
                            clampTo(aspectRatio || '16:9', ['21:9', '9:21', '16:9', '9:16', '9:7', '7:9', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'), `wan-2.7-${clampTo((image_resolution || '1K').toUpperCase(), ['1K', '2K', '4K'] as const, '1K')}`,
                        ),
                        seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                        // 可选参数
                        thinking_mode: typeof providerOptions?.thinking_mode === 'boolean' ? providerOptions.thinking_mode : false,
                        watermark: typeof providerOptions?.watermark === 'boolean' ? providerOptions.watermark : false,
                        // system
                        bbox_list: undefined,
                        enable_sequential: false,
                        n: 1,
                        color_palette: undefined,
                    },
                };
            }
        },
    },
    'wan2.7-image': {
        // https://bailian.console.aliyun.com/cn-beijing?spm=5176.12818093_47.overview_recent.3.e8292cc9QWCSs5&tab=api#/api/?type=model&url=3026980
        apiPath: '/api/v1/services/aigc/image-generation/generation',
        pollApiPath: '/api/v1/tasks/{id}',
        statusMapping: {
            taskIdPath: 'output.task_id',
            createErrorPath: 'message',
            statePath: 'output.task_status',
            success: ['SUCCEEDED'],
            failed: ['FAILED', 'CANCELED', 'UNKNOWN'],
            processing: ['PENDING', 'RUNNING'],
            imageUrlPath: 'output.choices[0].message.content[0].image',
            errorPath: 'output.message',
        },
        enableTranslation: false,
        buildInput: (params) => {
            const { prompt, image_urls, aspectRatio, image_resolution, providerOptions } = params;
            const hasImage = hasImageInput(image_urls);
            const images = image_urls.slice(0, 9);
            if (hasImage) {
                return {
                    model: 'wan2.7-image',
                    input: {
                        messages: [
                            {
                                role: 'user',
                                content: [
                                    {
                                        text: prompt.slice(0, 5000),
                                    },
                                    // 图片 URL
                                    ...images.map(url => ({
                                        image: url,
                                    })),
                                ]
                            }
                        ]
                    },
                    parameters: {
                        size: clampTo(image_resolution || '1K', ['1K', '2K'] as const, '1K'),
                        seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                        // 可选参数
                        watermark: typeof providerOptions?.watermark === 'boolean' ? providerOptions.watermark : false,
                        // system
                        bbox_list: undefined,
                        enable_sequential: false,
                        n: 1,
                        color_palette: undefined,
                    },
                };
            } else {
                return {
                    model: 'wan2.7-image',
                    input: {
                        messages: [
                            {
                                role: 'user',
                                content: [
                                    {
                                        text: prompt.slice(0, 5000),
                                    },
                                ]
                            }
                        ]
                    },
                    parameters: {
                        size: resolveImageSize(
                            clampTo(aspectRatio || '16:9', ['21:9', '9:21', '16:9', '9:16', '9:7', '7:9', '4:3', '3:4', '3:2', '2:3', '1:1'] as const, '16:9'),
                            `wan-2.7-${clampTo((image_resolution || '2K').toUpperCase(), ['1K', '2K'] as const, '2K')}`,
                        ),
                        seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                        // 可选参数
                        thinking_mode: typeof providerOptions?.thinking_mode === 'boolean' ? providerOptions.thinking_mode : false,
                        watermark: typeof providerOptions?.watermark === 'boolean' ? providerOptions.watermark : false,
                        // system
                        bbox_list: undefined,
                        enable_sequential: false,
                        n: 1,
                        color_palette: undefined,
                    },
                };
            }
        },
    },
};